<script>
export default {
  name: "WorkspaceJsonSkillcourtRotterdamLayout",
  props: ["zones"]
};
</script>
<template>
  <div class="layout-container">
    <div class="zone-group">
      <div class="zone-rest-outline">
        <img
          class="zone-layout"
          :class="{
            greenBackground: zones[0].is_occupied,
            yellowBackground: zones[0].is_maintenance
          }"
          src="../assets/LayoutAmsterdam/zone01-amsterdam.png"
          alt=""
        />
      </div>
      <div
        class="zone-rest-outline"
        :class="{
          greenBackground: zones[1].is_occupied,
          yellowBackground: zones[1].is_maintenance
        }"
      >
        <img
          class="zone-layout"
          src="../assets/LayoutAmsterdam/zone02-amsterdam.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.zone-layout {
  width: 100%;
  object-fit: contain;
  background: transparent;
  position: relative;
  z-index: 99;
}

.zone-group {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.zone-rest-outline {
  width: 240px;
  height: 240px;
  border-radius: 2px;
  border: solid 2px #767676;
  position: relative;
}

.zone-1-layout {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
}

.greenBackground {
  background-color: #1db75a;
}
.yellowBackground {
  background-color: #ffb818;
}
.transparentBackground {
  background-color: transparent;
}
</style>
